import React from "react";
import { Trans, useTranslation } from "react-i18next";

import {
  Button,
  Image,
  Spacing,
  Stack,
  Text,
} from "@noom/wax-component-library";

import {
  QuestionComponentProps,
  QuestionDefinition,
} from "@/components/survey/Question";
import {
  determineScaleEligibility,
  ScaleEligibility,
} from "@/utils/survey/scales";

import { BaseQuestion } from "../core";

const QUESTION_ID = "scaleEarningOptIn";

declare module "@/contexts" {
  interface SurveyAnswers {
    scaleEarningOptIn?: boolean;
  }
}

type Props = {
  isScaleSurvey?: boolean;
} & QuestionComponentProps;

const ScaleEarningOptInQuestion: React.FC<Props> = ({
  onClickNext,
  isScaleSurvey = false,
}) => {
  const { t } = useTranslation();
  const context = isScaleSurvey ? "ScaleSurvey" : undefined;

  return (
    <BaseQuestion
      hideHeader
      onClickBack={() => undefined}
      questionId={QUESTION_ID}
      questionText={t("scaleEarningOptIn.questionText", { context })}
    >
      <Image src="/assets/img/scale-earning.png" alt="Scale and app" />
      <Text>
        <Trans
          i18nKey="scaleEarningOptIn.questionHelperText"
          context={context}
        />
      </Text>
      <Stack spacing={Spacing[4]}>
        <Button
          colorScheme="primary"
          onClick={() => onClickNext(true)}
          size="xl"
          type="submit"
        >
          {t("scaleEarningOptIn.ctaText.yes")}
        </Button>
        <Button onClick={() => onClickNext(false)} size="xl" variant="outline">
          {t("scaleEarningOptIn.ctaText.no")}
        </Button>
      </Stack>
    </BaseQuestion>
  );
};

const ScaleEarningQuestionScaleSurvey: React.FC<QuestionComponentProps> = (
  props,
) => <ScaleEarningOptInQuestion {...props} isScaleSurvey />;

export const Q_SCALE_EARNING_OPT_IN: QuestionDefinition = {
  id: QUESTION_ID,
  shouldShowQuestion: (state) =>
    determineScaleEligibility(state) === ScaleEligibility.NOOMCOIN,
  component: ScaleEarningOptInQuestion,
};

export const Q_SCALE_EARNING_OPT_IN_SCALE_SURVEY: QuestionDefinition = {
  id: QUESTION_ID,
  shouldShowQuestion: (state) =>
    determineScaleEligibility(state) === ScaleEligibility.NOOMCOIN,
  component: ScaleEarningQuestionScaleSurvey,
};
